import { Component } from 'react';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
import { ErrorBoundaryError } from '../errors/ErrorBoundaryError';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
    logger.error(new ErrorBoundaryError(error.message, {
      boundaryName: this.props.boundaryName,
      cause: error
    }));
  }
  render() {
    const {
      hasError
    } = this.state;
    const errorComponent = this.props.errorComponent ? this.props.errorComponent : null;
    if (hasError) {
      return errorComponent;
    }
    return this.props.children;
  }
}
const getComponentName = component => 'displayName' in component ? component.displayName : 'name' in component ? component.name : 'Component';
export const withErrorBoundary = (WrappedComponent, options) => {
  const Wrapper = props => /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, options, {
    children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
  }));
  Wrapper.displayName = `withErrorBoundary(${getComponentName(WrappedComponent)})`;
  Wrapper.wrappedComponent = WrappedComponent;
  return Wrapper;
};
export default ErrorBoundary;